module.exports = __webpack_public_path__ + "static/media/11.9222ddd6.jpg";